export enum RecommendationSource {
    DISTANCE,
    MODEL
}
